export const mockData = [
  {
    userId: "157",
    userName: "123123",
    beneficiaryId: "8379",
    beneficiaryName: "won",
    receiverType: "Individual",
    receivingMethod: "Bank Transfer",
    phone: "--",
    status: "--",
    details: {
      country: "South Korea",
      currency: "South Korean Won",
      relationship: "Family",
      idType: "Passport",
      idNumber: "M9381283",
      idExpiredDate: "12/12/2030",
      dob: "05/05/1990",
      firstName: "won",
      middleName: "-",
      middleInitial: "-",
      lastName: "-",
      jointAccountHolder: "-",
      tin: "-",
      companyRegNo: "-",
      nativeName: "원",
      contactNumber: "--",
      address: "123 Seoul St.",
      city: "Seoul",
      state: "Seoul",
      postalCode: "100-011",
      suburb: "-",
      bankName: "Kookmin Bank",
      cashPickupLocation: "-",
      iban: "-",
      accountNumber: "1298409121",
      accountType: "Savings",
      bankAccountTitle: "Won Ryu",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "Gangnam Branch",
      branchCode: "110",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "157",
    userName: "123123",
    beneficiaryId: "8378",
    beneficiaryName: "Susan",
    receiverType: "Individual",
    receivingMethod: "Bank Transfer",
    phone: "--",
    status: "--",
    details: {
      country: "USA",
      currency: "US Dollar",
      relationship: "Friend",
      idType: "Driver's License",
      idNumber: "D90123812",
      idExpiredDate: "01/01/2028",
      dob: "10/12/1985",
      firstName: "Susan",
      middleName: "Marie",
      middleInitial: "M",
      lastName: "Smith",
      jointAccountHolder: "-",
      tin: "-",
      companyRegNo: "-",
      nativeName: "-",
      contactNumber: "--",
      address: "456 Oak Avenue",
      city: "New York",
      state: "NY",
      postalCode: "10001",
      suburb: "Manhattan",
      bankName: "Chase Bank",
      cashPickupLocation: "-",
      iban: "US12CHAS39201940",
      accountNumber: "9876543210",
      accountType: "Checking",
      bankAccountTitle: "Susan Smith",
      transitNumber: "021000021",
      sortCode: "-",
      routingNumber: "021000021",
      bsbNumber: "-",
      branchName: "Midtown",
      branchCode: "123",
      branchNumber: "456",
      ifscNumber: "-",
    }
  },
  {
    userId: "10843",
    userName: "Thuy Nga Phan",
    beneficiaryId: "8377",
    beneficiaryName: "Thuynga Check level limit",
    receiverType: "Organization",
    receivingMethod: "Bank Transfer",
    phone: "+65 1234 567 8900",
    status: "Approved",
    details: {
      country: "Singapore",
      currency: "Singapore Dollar",
      relationship: "Business Partner",
      idType: "Company Registration",
      idNumber: "UEN202012345A",
      idExpiredDate: "12/31/2099",
      dob: "-",
      firstName: "Thuynga Check level limit",
      middleName: "-",
      middleInitial: "-",
      lastName: "-",
      jointAccountHolder: "-",
      tin: "T1234567X",
      companyRegNo: "UEN202012345A",
      nativeName: "-",
      contactNumber: "+65 1234 567 8900",
      address: "8 Marina View",
      city: "Singapore",
      state: "Singapore",
      postalCode: "018960",
      suburb: "Downtown Core",
      bankName: "DBS Bank",
      cashPickupLocation: "-",
      iban: "SG12DBSB0123456789",
      accountNumber: "123-456-789-0",
      accountType: "Corporate",
      bankAccountTitle: "Thuynga Business Services",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "7171",
      bsbNumber: "-",
      branchName: "Marina Bay",
      branchCode: "001",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "10844",
    userName: "Quang Nguyen",
    beneficiaryId: "8376",
    beneficiaryName: "SparkMinds",
    receiverType: "Organization",
    receivingMethod: "Bank Transfer",
    phone: "--",
    status: "--",
    details: {
      country: "Vietnam",
      currency: "Vietnamese Dong",
      relationship: "Employer",
      idType: "Business License",
      idNumber: "0312019231",
      idExpiredDate: "09/09/2040",
      dob: "-",
      firstName: "SparkMinds",
      middleName: "-",
      middleInitial: "-",
      lastName: "-",
      jointAccountHolder: "-",
      tin: "0312019231",
      companyRegNo: "0312019231",
      nativeName: "Công ty SparkMinds",
      contactNumber: "--",
      address: "123 District 1",
      city: "Ho Chi Minh City",
      state: "Ho Chi Minh",
      postalCode: "700000",
      suburb: "District 1",
      bankName: "Vietcombank",
      cashPickupLocation: "-",
      iban: "-",
      accountNumber: "018100123984",
      accountType: "Corporate",
      bankAccountTitle: "SparkMinds LLC",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "HCM Branch",
      branchCode: "018",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "10843",
    userName: "Thuy Nga Phan",
    beneficiaryId: "8375",
    beneficiaryName: "Thuy Nga Check limit",
    receiverType: "Individual",
    receivingMethod: "Bank Transfer",
    phone: "+65 1234 567 8901",
    status: "Approved",
    details: {
      country: "Malaysia",
      currency: "Malaysian Ringgit",
      relationship: "Business partner",
      idType: "National ID",
      idNumber: "780101-14-5555",
      idExpiredDate: "01/01/2050",
      dob: "01/01/1978",
      firstName: "Thuy Nga",
      middleName: "-",
      middleInitial: "-",
      lastName: "Phan",
      jointAccountHolder: "Susan",
      tin: "SG1239102",
      companyRegNo: "-",
      nativeName: "-",
      contactNumber: "+65 1234 567 8901",
      address: "45 Jalan Ampang",
      city: "Kuala Lumpur",
      state: "Federal Territory",
      postalCode: "50450",
      suburb: "KLCC",
      bankName: "AFFIN BANK BERHAD",
      cashPickupLocation: "-",
      iban: "-",
      accountNumber: "123456789",
      accountType: "Savings",
      bankAccountTitle: "Thuy Nga limit Account",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "KL Main",
      branchCode: "014",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "144",
    userName: "SparkMinds",
    beneficiaryId: "8374",
    beneficiaryName: "indo org 024",
    receiverType: "Organization",
    receivingMethod: "Cash Pickup",
    phone: "--",
    status: "Approved",
    details: {
      country: "Indonesia",
      currency: "Indonesian Rupiah",
      relationship: "Vendor",
      idType: "Corporate ID",
      idNumber: "IDORG-024",
      idExpiredDate: "10/10/2030",
      dob: "-",
      firstName: "indo org 024",
      middleName: "-",
      middleInitial: "-",
      lastName: "-",
      jointAccountHolder: "-",
      tin: "NPWP 12.345.678.9-012.000",
      companyRegNo: "NIB 9876543210987",
      nativeName: "Perusahaan Indo 024",
      contactNumber: "--",
      address: "Jl. Sudirman No 42",
      city: "Jakarta",
      state: "DKI Jakarta",
      postalCode: "12190",
      suburb: "Kebayoran Baru",
      bankName: "-",
      cashPickupLocation: "Alfamart Sudirman 42",
      iban: "-",
      accountNumber: "-",
      accountType: "-",
      bankAccountTitle: "-",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "-",
      branchCode: "-",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "144",
    userName: "SparkMinds",
    beneficiaryId: "8373",
    beneficiaryName: "indo cash pickup",
    receiverType: "Individual",
    receivingMethod: "Cash Pickup",
    phone: "--",
    status: "--",
    details: {
      country: "Indonesia",
      currency: "Indonesian Rupiah",
      relationship: "Contractor",
      idType: "KTP",
      idNumber: "3171234567890001",
      idExpiredDate: "12/31/2099",
      dob: "12/12/1990",
      firstName: "Indo",
      middleName: "Cash",
      middleInitial: "-",
      lastName: "Pickup",
      jointAccountHolder: "-",
      tin: "-",
      companyRegNo: "-",
      nativeName: "-",
      contactNumber: "--",
      address: "Block M Square",
      city: "Jakarta",
      state: "DKI Jakarta",
      postalCode: "12160",
      suburb: "Melawai",
      bankName: "-",
      cashPickupLocation: "Indomaret Block M",
      iban: "-",
      accountNumber: "-",
      accountType: "-",
      bankAccountTitle: "-",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "-",
      branchCode: "-",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "639",
    userName: "Thuy Nga Phan",
    beneficiaryId: "8372",
    beneficiaryName: "BDO BDO BDO BDO",
    receiverType: "Individual",
    receivingMethod: "Bank Transfer",
    phone: "+65 1231 231 2312",
    status: "Approved",
    details: {
      country: "Philippines",
      currency: "Philippine Peso",
      relationship: "Relative",
      idType: "TIN ID",
      idNumber: "123-456-789-000",
      idExpiredDate: "05/05/2030",
      dob: "08/08/1988",
      firstName: "BDO BDO",
      middleName: "-",
      middleInitial: "-",
      lastName: "BDO BDO",
      jointAccountHolder: "-",
      tin: "123-456-789-000",
      companyRegNo: "-",
      nativeName: "-",
      contactNumber: "+65 1231 231 2312",
      address: "789 Ayala Ave.",
      city: "Makati",
      state: "Metro Manila",
      postalCode: "1226",
      suburb: "San Lorenzo",
      bankName: "BDO Unibank",
      cashPickupLocation: "-",
      iban: "-",
      accountNumber: "001234567890",
      accountType: "Savings",
      bankAccountTitle: "BDO Account Owner",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "Ayala-Makati",
      branchCode: "00123",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "481",
    userName: "QC",
    beneficiaryId: "8371",
    beneficiaryName: "Hanh Nguyen",
    receiverType: "Individual",
    receivingMethod: "Cash Pickup",
    phone: "--",
    status: "Approved",
    details: {
      country: "Vietnam",
      currency: "Vietnamese Dong",
      relationship: "Family",
      idType: "CCCD",
      idNumber: "079199011111",
      idExpiredDate: "03/03/2050",
      dob: "03/03/1999",
      firstName: "Hanh",
      middleName: "-",
      middleInitial: "-",
      lastName: "Nguyen",
      jointAccountHolder: "-",
      tin: "-",
      companyRegNo: "-",
      nativeName: "Nguyễn Hạnh",
      contactNumber: "--",
      address: "456 CMT8",
      city: "Ho Chi Minh City",
      state: "Ho Chi Minh",
      postalCode: "700000",
      suburb: "District 3",
      bankName: "-",
      cashPickupLocation: "Western Union CMT8",
      iban: "-",
      accountNumber: "-",
      accountType: "-",
      bankAccountTitle: "-",
      transitNumber: "-",
      sortCode: "-",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "-",
      branchCode: "-",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
  {
    userId: "595",
    userName: "Thuy Nga Phan",
    beneficiaryId: "8370",
    beneficiaryName: "aml bnf bnf",
    receiverType: "Individual",
    receivingMethod: "Bank Transfer",
    phone: "+65 1539 756 8063",
    status: "Approved",
    details: {
      country: "United Kingdom",
      currency: "British Pound",
      relationship: "Client",
      idType: "Passport",
      idNumber: "P12398555",
      idExpiredDate: "06/06/2032",
      dob: "04/04/1984",
      firstName: "aml",
      middleName: "bnf",
      middleInitial: "b",
      lastName: "bnf",
      jointAccountHolder: "-",
      tin: "-",
      companyRegNo: "-",
      nativeName: "-",
      contactNumber: "+65 1539 756 8063",
      address: "70 Oxford St.",
      city: "London",
      state: "England",
      postalCode: "W1D 1BS",
      suburb: "West End",
      bankName: "Barclays Bank",
      cashPickupLocation: "-",
      iban: "GB12BARC20000012345678",
      accountNumber: "12345678",
      accountType: "Current",
      bankAccountTitle: "AML Bnf Bnf",
      transitNumber: "-",
      sortCode: "20-00-00",
      routingNumber: "-",
      bsbNumber: "-",
      branchName: "Oxford Circus",
      branchCode: "-",
      branchNumber: "-",
      ifscNumber: "-",
    }
  },
];
